import React from 'react';
export function Hero() {
  const handleBuyClick = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 14990,
        currency: 'ARS'
      });
    }
  };
  return <section className="hero flex flex-col items-center justify-center pt-[42px] md:pt-[72px] px-4 md:px-5 pb-[40px] md:pb-[60px] overflow-hidden bg-[radial-gradient(ellipse_100%_80%_at_50%_0%,rgba(44,37,64,0.25)_0%,transparent_60%)] relative z-10" data-id="element-198">
      <div className="c flex flex-col items-center relative z-10 w-full" data-id="element-199">
        <div className="hero-badge fu inline-flex items-center justify-center gap-[7px] py-1.5 px-3 md:px-4 rounded-full border border-[rgba(232,150,12,0.5)] bg-[rgba(232,150,12,0.1)] text-[10px] md:text-[11px] tracking-[0.14em] uppercase text-[var(--gold-l)] font-bold mb-4 md:mb-[22px] backdrop-blur-sm text-center" data-id="element-200">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" data-id="element-201">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-202" />
          </svg>
          Método: Alma Imparable - Kit Completo de Sanación -
        </div>

        <h1 className="fu font-serif text-[clamp(3rem,9vw,5.8rem)] font-700 leading-[1.15] text-center text-white tracking-[-0.01em] mb-3 md:mb-[18px]" style={{
        transitionDelay: '.12s'
      }} data-id="element-203">
          Dejá de hablar del dolor.
          <br data-id="element-204" />
          <em className="italic text-[var(--gold-l)]" data-id="element-205">Es hora de cerrarlo.</em>
        </h1>

        <p className="hero-sub fu font-serif text-[clamp(1.1rem,2.5vw,1.5rem)] text-[var(--lila-pale)] text-center italic max-w-[600px] mb-3 md:mb-5 leading-[1.45]" style={{
        transitionDelay: '.22s'
      }} data-id="element-206">
          ¡ESTE DOLOR NO ES MIO. SOLTÁ EN 21 DIAS AQUELLO QUE NO TE PERTENECE!
        </p>

        <p className="hero-body fu text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] text-center max-w-[600px] mb-6 md:mb-[36px] leading-[1.9] opacity-90 font-400" style={{
        transitionDelay: '.32s'
      }} data-id="element-207">
          Un proceso guiado y diseñado para cerrar ciclos emocionales que tu
          mente no ha podido soltar.
          <br data-id="element-208" />
          <br data-id="element-209" />
          En pocos días pasarás de sentirte atrapada en recuerdos, pensamientos
          repetitivos y emociones que pesan…a experimentar una sensación real de
          liberación, claridad y tranquilidad emocional.
        </p>

        <div className="fu flex flex-col items-center gap-2.5 w-full" style={{
        transitionDelay: '.42s'
      }} data-id="element-210">
          <a href="#pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="btn-cta full" data-id="element-211">
            Quiero mi Kit Completo $14.990
          </a>
          <div className="trust flex items-center gap-2 text-[11px] md:text-[12px] text-[var(--text)] opacity-75 mt-2 flex-wrap justify-center" data-id="element-212">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-213">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-214" />
            </svg>
            Pago seguro · Descarga inmediata · Garantía 7 días
          </div>
        </div>

        <div className="hero-img-w fu mt-7 md:mt-[44px] relative animate-[float_6s_ease-in-out_infinite]" style={{
        transitionDelay: '.52s'
      }} data-id="element-215">
          <div className="absolute -inset-6 bg-[radial-gradient(circle,rgba(184,174,206,0.4)_0%,rgba(255,107,53,0.15)_40%,transparent_70%)] rounded-full blur-[16px]" data-id="element-216" />
          <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BUNDLE.png?v=1772835860" alt="33 Rituales para Soltar el Pasado — Kit Completo" className="relative z-10 w-[clamp(200px,min(85vw,300px),400px)] rounded-[10px] border border-[rgba(184,174,206,0.3)] shadow-[0_24px_70px_-15px_rgba(44,37,64,0.6),0_8px_32px_rgba(255,107,53,0.15)] mx-auto block" data-id="element-217" />
        </div>
      </div>
    </section>;
}